export default "__VITE_ASSET__953b6616__"